import { observer } from 'mobx-react-lite'

import { OwnerLettersTab } from '@/Containers/CommunicationSection/LetterContainer/Hooks'

import type { CrmOwnerFormContextLike } from '../Owner/CrmOwnerFormContext'

export interface CrmLettersTabProps {
    /** Чия картка: поле власника в листі */
    owner: 'client' | 'carrier' | 'clientContact' | 'carrierContact'
    /** `formContext` картки власника — звідти лише `uuid` */
    ownerFormContext: CrmOwnerFormContextLike | undefined
}

/**
 * Вкладка «Листи» картки власника CRM (`SPEC-008` §3.4, §7.1; `SPEC-013`
 * §9.2) — каркас: вміст дає публічне API контейнера листів
 * (`LetterContainer/Hooks`), а не прямий імпорт його компонентів.
 *
 * Значень власника, які редагують, вкладка не читає — лише `uuid`
 * (`SPEC-002` §4.2): адресатів і шаблони бере сам контейнер листів.
 */
export const CrmLettersTab = observer(({ owner, ownerFormContext }: CrmLettersTabProps) => (
    <OwnerLettersTab owner={owner} record={{ uuid: ownerFormContext?.values?.uuid }} />
))
